import React, { useState } from "react";
import "../aseets/css/FeaturedJobOffers.css";

const jobsData = [
  {
    id: 1,
    category: "Finance",
    title: "Financial Analyst",
    location: "Pune, India",
    type: "Full Time",
    company: "Global Manch",
  },
  {
    id: 2,
    category: "Engineering",
    title: "Fullstack Web Developer",
    location: "Remote",
    type: "Full Time",
    company: "Global Manch",
  },
  {
    id: 3,
    category: "HR",
    title: "Human Resource Coordinator",
    location: "Pune, India",
    type: "Full Time",
    company: "Global Manch",
  },
  {
    id: 4,
    category: "Content",
    title: "Technical Writer",
    location: "Remote",
    type: "Contract",
    company: "Global Manch",
  },
];

const FeaturedJobOffers = () => {
  const [activeJob, setActiveJob] = useState(null);

  return (
    <>
      <section className="gm-jobs">
        <div className="gm-jobs-header">
          <h2>Featured Job Offers</h2>
          <p>Explore opportunities crafted for creative and driven professionals.</p>
        </div>

        <div className="gm-jobs-grid">
          {jobsData.map((job) => (
            <div className="gm-job-card" key={job.id}>
              <span className="gm-job-category">{job.category}</span>

              <h3 className="gm-job-title">{job.title}</h3>

              <div className="gm-job-meta">
                <span>{job.location}</span>
                <span>•</span>
                <span>{job.type}</span>
              </div>

              <div className="gm-job-footer">
                <span className="gm-job-company">{job.company}</span>
                <button
                  className="gm-apply-btn"
                  onClick={() => setActiveJob(job)}
                >
                  Apply Now
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* MODAL */}
      {activeJob && (
        <div className="gm-modal-backdrop" onClick={() => setActiveJob(null)}>
          <div
            className="gm-modal"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Apply for {activeJob.title}</h3>

            <form className="gm-apply-form">
              <input type="text" placeholder="Full Name" required />
              <input type="email" placeholder="Email Address" required />
              <input type="tel" placeholder="Phone Number" />

              <select defaultValue="">
                <option value="" disabled>
                  Years of Experience
                </option>
                <option>0 – 1</option>
                <option>1 – 3</option>
                <option>3 – 5</option>
                <option>5+</option>
              </select>

              <input type="file" />

              <textarea placeholder="Why should we hire you?" rows="4" />

              <button type="submit" className="gm-submit-btn">
                Submit Application
              </button>
            </form>

            <button
              className="gm-modal-close"
              onClick={() => setActiveJob(null)}
            >
              ✕
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default FeaturedJobOffers;
